import type { MonetaryAmountDto } from "./MonetaryAmountDto";

export enum TenderListingInfoStatus {
    "DRAFT" = "DRAFT",
    "ACCEPTANCE_PROPOSALS" = "ACCEPTANCE_PROPOSALS",
    "DOCUMENTS_ACCEPTANCE" = "DOCUMENTS_ACCEPTANCE",
    "REVIEW_PROPOSALS" = "REVIEW_PROPOSALS",
    "REBIDDING" = "REBIDDING",
    "COMPLETED" = "COMPLETED"
}
export enum TenderListingInfoProcessingStatus {
    "ITEMS_FILE_ERROR" = "ITEMS_FILE_ERROR",
    "ITEMS_FILE_SUCCESS" = "ITEMS_FILE_SUCCESS",
    "ITEMS_FILE_IN_PROGRESS" = "ITEMS_FILE_IN_PROGRESS"
}
export type TenderListingInfo = {
    /**
     * @type integer int64
    */
    id: number;
    /**
     * @type string uuid
    */
    uid: string;
    /**
     * @type string | undefined
    */
    name?: string;
    /**
     * @type string | undefined date-time
    */
    startDateProposals?: string;
    /**
     * @type string | undefined date-time
    */
    endDateProposals?: string;
    /**
     * @type string
    */
    status: TenderListingInfoStatus;
    /**
     * @type string | undefined
    */
    processingStatus?: TenderListingInfoProcessingStatus;
    cost?: MonetaryAmountDto;
};
